<template>
  <div class="container-fluid">
    <div class="card m-1">
        <div class="card-body d-flex">
          <div>
            External Media to Account Assigner
            <div class="text-left mt-1" style="font-weight: 300; font-size: 0.8em;">
              This tool, <b>built for the membership and communication teams</b>, is to mark which accounts were discussed in newsletters. This is to improve reporting for member involvement with the Association.
            </div>
            <div class="d-flex">
              <div v-for="taggableObject in taggableObjects.filter((x) => x.isShown)" :key="taggableObject.value">
                <button class="btn maadi-button btn-sm m-2" :class="taggableObject.value === externalMediaType ? 'selected': ''" @click="setExternalMediaType(taggableObject.value)">{{ taggableObject.name }}</button>
              </div>
            </div>
          </div>
          <!-- Removed for relevance -- <div class="ml-auto d-flex align-items-center">
            <button class="btn maadi-button" @click="launchMediaMentionForm" >Add Media Mention</button>
          </div> -->
        </div>
    </div>
    <!-- Removed for relevance --<b-modal v-model="showModal" id="modal-1" size="lg" title="BootstrapVue" hide-footer hide-header>
      <external-media-form  v-on:mentionCreated="newMentionCreated"></external-media-form>
    </b-modal> -->
    <div class="row" v-if="externalMediaObjects !== null" >
      <div class="col-4">
        <div class="card m-1">
          <div class="card-body">
            <div style="height: 65vh; overflow-y: scroll">
              <div @click="setExternalMediaObject(campaign.id)" class="d-flex m-1 p-1" v-for="campaign in externalMediaObjects" :key="campaign.id" style="background: #eee; cursor: pointer;">
                <div class="d-flex flex-column">
                  <div>
                    {{ campaign.title !== null ? campaign.title.substring(0, 50) : campaign.title }}...
                  </div>
                  <div style="font-weight: 300">
                    {{ campaign.date | formatDateTime }}
                  </div>
                </div>
                <b-icon icon="exclamation-circle-fill" variant="danger" v-if="campaign.count === 0" class="p-3 ml-auto mr-2"></b-icon>
                <div v-else class="p-3 ml-auto">
                  {{ campaign.count }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8" v-if="mountedObject !== null" >
        <div class="card m-1">
          <div class="card-body d-flex">
            <div>{{ mountedTitle }}</div>
            <div class="ml-auto">{{ mountedObject.date | formatDate }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="card m-1">
              <div class="card-body">
                <div class="text-center" v-if="!loadingMountedCampaign">
                  <div style="font-weight: 300">
                    Enter Company/Individual
                  </div>
                  <div class="d-flex flex-column">
                    <account-selector v-on:selectedAccount="(e) => { setAccount(e) }"></account-selector>
                    <div class="p-1 d-flex mb-1" v-for="account in mountedObject.accounts" :key="account.account_id" style="border: solid 1px #ddd; font-size: 0.8em;">
                      <div class="d-flex flex-fill p-1 align-items-center">
                        <div>
                          <div class="text-left">{{ account.name }}</div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="ml-auto p-2">
                          <i class="fas fa-times" v-on:click="removeAccount(account)" style="cursor: pointer"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-9">
            <div class="card m-1">
              <div class="card-body">
                <div class="p-1" >
                  <div v-if="loadingMountedCampaign">
                    <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
                  </div>
                </div>
                <div class="p-1">
                  <mail-chimp-media-object v-bind:mediaObject="mountedObject" v-if="externalMediaType === 'mailchimp_campaign'"></mail-chimp-media-object>
                  <twitter-media-object v-bind:mediaObject="mountedObject" v-if="externalMediaType === 'tweet'"></twitter-media-object>
                  <word-press-object v-bind:mediaObject="mountedObject" v-if="externalMediaType === 'wordpress_post'"></word-press-object>
                  <community-events-object v-bind:mediaObject="mountedObject" v-if="externalMediaType === 'community_events'"></community-events-object>
                  <podcast-object v-bind:mediaObject="mountedObject" v-if="externalMediaType === 'podcast'"></podcast-object>
                  <linked-in-object v-bind:mediaObject="mountedObject" v-if="externalMediaType === 'linkedin'"></linked-in-object>
                  <webinar-object v-bind:mediaObject="mountedObject" v-if="externalMediaType === 'webinar'"></webinar-object>
                  <!-- Removed for relevance -- <media-mention-object v-bind:mediaObject="mountedObject" v-if="externalMediaType === 'media_mention'"></media-mention-object> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountSelector from '../tools/AccountSelector'
import API from '../../api/_services'
import MailChimpMediaObject from './MailChimpMediaObject'
import TwitterMediaObject from './TwitterMediaObject'
import WordPressObject from './WordPressObject'
// --Removed for relevance-- import ExternalMediaForm from './ExternalMediaForm'
import CommunityEventsObject from './CommunityEventsObject'
import PodcastObject from './PodcastObject'
import LinkedInObject from './LinkedInObject'
import WebinarObject from './WebinarObject'
// Removed for relevance -- import MediaMentionObject from './MediaMentionObject'

export default {
  name: 'ExternalMediaAssigner',
  components: {
    AccountSelector,
    MailChimpMediaObject,
    TwitterMediaObject,
    WordPressObject,
    // --Removed for relevance-- ExternalMediaForm,
    CommunityEventsObject,
    PodcastObject,
    LinkedInObject,
    WebinarObject,
    // Removed for relevance -- MediaMentionObject
  },
  computed: {
    mountedTitle () {
      if (this.mountedObject === null || this.mountedObject.title === null) {
        return ''
      }
      if (this.mountedObject === 'mailchimp_campaign') {
        return this.mountedObject.title
      }
      if (this.mountedObject === 'community_events') {
        return this.mountedObject.title
      }
      let title = this.mountedObject.title
      return title.substring(0, 50) + '...'
    }
  },
  data: function () {
    return {
      externalMediaObjects: null,
      mountedObject: null,
      loadingMountedCampaign: false,
      externalMediaType: 'mailchimp_campaign',
      showModal: false,
      taggableObjects: [
        {
          name: 'MailChimp',
          value: 'mailchimp_campaign',
          isShown: this.$store.getters.hasCapabilities('membership_tools') || this.$store.getters.hasAdministrator
        },
        {
          name: 'Twitter',
          value: 'tweet',
          isShown: this.$store.getters.hasCapabilities('membership_tools') || this.$store.getters.hasAdministrator
        },
        {
          name: 'LinkedIn',
          value: 'linkedin',
          isShown: this.$store.getters.hasCapabilities('membership_tools') || this.$store.getters.hasAdministrator
        },
        {
          name: 'WordPress',
          value: 'wordpress_post',
          isShown: this.$store.getters.hasCapabilities('membership_tools') || this.$store.getters.hasAdministrator
        },
        {
          name: 'Community Events',
          value: 'community_events',
          isShown: true // this.$store.getters.hasCapabilities('communication_tools') || this.$store.getters.hasAdministrator
        },
        {
          name: 'Podcasts',
          value: 'podcast',
          isShown: this.$store.getters.hasCapabilities('membership_tools') || this.$store.getters.hasAdministrator
        },
        {
          name: 'Webinars',
          value: 'webinar',
          isShown: this.$store.getters.hasCapabilities('membership_tools') || this.$store.getters.hasAdministrator
        },
        // {
        //   name: 'Media Mentions',
        //   value: 'media_mention',
        //   isShown: true 
        //   // This was commented out before isShown: this.$store.getters.hasCapabilities('communication_tools') || this.$store.getters.hasAdministrator
        // }
      ]
    }
  },
  methods: {
    newMentionCreated (e) {
      this.showModal = false
      this.setExternalMediaObjects()
    },
    // --Removed for relevance -- launchMediaMentionForm () {
    //   this.setExternalMediaType('media_mention')
    //   this.showModal = true
    // },
    setAccount (account) {
      this.loadingMountedCampaign = true
      API.post(process.env.ROOT_API + '/external_media/' + this.externalMediaType + '/' + this.mountedObject.id + '/' + account.account_id).then(
        response => {
          this.setExternalMediaObject(this.mountedObject.id, true)
        }
      )
    },
    removeAccount (account) {
      this.loadingMountedCampaign = true
      API.deleteCall(process.env.ROOT_API + '/external_media/' + this.externalMediaType + '/' + this.mountedObject.id + '/' + account.account_id).then(
        response => {
          this.setExternalMediaObject(this.mountedObject.id, true)
        }
      )
    },
    setExternalMediaType (mediaType) {
      this.externalMediaType = mediaType
      this.setExternalMediaObjects()
    },
    setExternalMediaObjects () {
      this.mountedObject = null
      API.get(process.env.ROOT_API + '/external_media/' + this.externalMediaType).then(
        response => {
          this.externalMediaObjects = response.data.data
          if (this.externalMediaObjects.length > 0) {
            this.setExternalMediaObject(this.externalMediaObjects[0].id)
          }
        }
      )
    },
    setExternalMediaObject (objectID, justSetAccounts = false) {
      if (!justSetAccounts) {
        this.mountedObject = null
      }
      this.loadingMountedCampaign = true
      API.get(process.env.ROOT_API + '/external_media/' + this.externalMediaType + '/' + objectID).then(
        response => {
          if (justSetAccounts) {
            this.mountedObject['accounts'] = response.data.data['accounts']
          } else {
            this.mountedObject = response.data.data
          }
          this.loadingMountedCampaign = false
        }
      )
    }
  },
  mounted () {
    this.setExternalMediaObjects()
  }
}
</script>

<style scoped>
  .selected {
    background: #3E597A;
    color: #FFFFFF;
  }
  .sub-type {
    font-weight: 700;
    color: #cccccc;
    font-size: 1.0em;
    cursor: pointer;
  }
  .sub-type-selected {
    color: #BE1E2D;
  }
</style>



// WEBPACK FOOTER //
// src/components/socialMedia/ExternalMediaAssigner.vue